import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 

import "ag-grid-community/styles/ag-grid.css"; // Core Grid CSS
import "ag-grid-community/styles/ag-theme-alpine.css"; // Theme CSS

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

const initialRows = Array.from({ length: 300 }, (_, id) => ({
  id,
  name: `Row ${id + 1}`,
  age: Math.floor(Math.random() * 100),
  city: `City ${id % 10}`,
  country: id % 2 === 0 ? "USA" : "Canada",
}));

export default function FinishTable2() {
  const [rowData, setRowData] = useState(initialRows);

  const columnDefs = [
    { field: "id", headerName: "ID" },
    { field: "name", headerName: "Name", editable: true },
    { field: "age", headerName: "Age", editable: true },
    { field: "city", headerName: "City", editable: true },
    { field: "country", headerName: "Country", editable: true },
  ];

  return (
    <div className="ag-theme-alpine" style={{ height: 600, width: "100%" }}>
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        domLayout="autoHeight"
		singleClickEdit={true} 
      />
    </div>
  );
}
